import React from 'react';
import { Check, TrendingDown } from 'lucide-react';
const WhyThopen = () => {
  return <section className="py-20 bg-white flex items-center justify-center">
      <div className="max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Por que a Thopen{' '}
            <span className="bg-gradient-to-r from-thopen-pink to-thopen-yellow bg-clip-text text-transparent">
              cabe melhor no seu planejamento?
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Com energia renovável, a Thopen reduz o custo da sua energia, substituindo a forma tradicional de consumo por uma alternativa sustentável com até 15% de economia.
          </p>
        </div>

        {/* Comparison Section */}
        <div className="bg-gradient-to-r from-pink-50 to-yellow-50 rounded-3xl p-6 md:p-10 lg:p-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Entenda sua conta de energia
          </h3>

          {/* Comparison Cards */}
          <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
            {/* Conta Convencional */}
            <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-gray-100">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-3 h-3 rounded-full bg-gray-400"></div>
                <h4 className="text-lg font-semibold text-gray-700">Conta convencional</h4>
              </div>

              <div className="space-y-4">
                <div className="flex items-center justify-between py-3 border-b border-gray-100">
                  <span className="text-gray-600">Energia Convencional (TE):</span>
                  <span className="font-semibold text-gray-900">R$ 120,00</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-100">
                  <span className="text-gray-600">Distribuidora (TUSD):</span>
                  <span className="font-semibold text-gray-900">R$ 192,00</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-100">
                  <span className="text-gray-600">Encargos e Tributos:</span>
                  <span className="font-semibold text-gray-900">R$ 88,00</span>
                </div>
                <div className="flex items-center justify-between pt-4">
                  <span className="text-gray-900 font-bold text-lg">Total:</span>
                  <span className="text-2xl font-bold text-gray-900">R$ 400,00</span>
                </div>
              </div>
            </div>

            {/* Conta com Thopen */}
            <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-lg border-2 border-thopen-pink/20 relative overflow-hidden">
              {/* Highlight badge */}
              <div className="absolute top-0 right-0 bg-gradient-to-r from-thopen-pink to-thopen-yellow text-white text-xs font-semibold px-4 py-1 rounded-bl-xl">
                RECOMENDADO
              </div>

              <div className="flex items-center gap-2 mb-6">
                <div className="w-3 h-3 rounded-full bg-gradient-to-r from-thopen-pink to-thopen-yellow"></div>
                <h4 className="text-lg font-semibold text-gray-900">Conta com Thopen</h4>
              </div>

              <div className="space-y-4">
                <div className="flex items-center justify-between py-3 border-b border-gray-100 bg-gradient-to-r from-pink-50/50 to-yellow-50/50 -mx-2 px-2 rounded-lg">
                  <div className="flex items-center gap-2">
                    <TrendingDown className="w-4 h-4 text-thopen-pink" />
                    <span className="text-gray-700 font-medium">Energia Thopen:</span>
                  </div>
                  <span className="font-bold text-thopen-pink">R$ 102,00</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-100">
                  <span className="text-gray-600">Distribuidora (TUSD):</span>
                  <span className="font-semibold text-gray-900">R$ 192,00</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-100">
                  <span className="text-gray-600">Encargos e Tributos:</span>
                  <span className="font-semibold text-gray-900">R$ 50,00</span>
                </div>
                <div className="flex items-center justify-between pt-4">
                  <span className="text-gray-900 font-bold text-lg">Total:</span>
                  <span className="text-2xl font-bold bg-gradient-to-r from-thopen-pink to-thopen-yellow bg-clip-text text-transparent">R$ 344,00</span>
                </div>
              </div>
            </div>
          </div>

          {/* Savings Highlight */}
          <div className="mt-8 text-center">
            <div className="inline-flex items-center gap-3 bg-white px-6 py-3 shadow-md border border-thopen-pink/10 rounded-xl">
              <div className="flex items-center justify-center shrink-0 w-8 h-8 rounded-full bg-gradient-to-r from-thopen-pink to-thopen-yellow">
                <Check className="w-5 h-5 text-white" />
              </div>
              <div className="text-left">
                <div className="text-lg font-bold text-balance bg-gradient-to-r from-thopen-pink to-thopen-yellow bg-clip-text text-transparent">
                  Até 15% de desconto na energia
                </div>
                <div className="text-sm text-gray-600">
                  "Nossos clientes economizam até 15% na energia da conta."
                </div>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <p className="text-xs text-gray-500 text-center mt-6 max-w-2xl mx-auto italic">
            *Os valores apresentados são apenas exemplos simples, para facilitar o entendimento, e podem variar conforme a região, distribuidora e perfil de consumo. A economia e os valores da conta podem sofrer alterações mês a mês.
          </p>
        </div>
      </div>
    </section>;
};
export default WhyThopen;